import React from 'react'
import OfferForm from '../../components/common/OfferForm';

const NewOffer = ({merchant}) => {
  return (
    <OfferForm merchant={merchant}/>
  )
}

export default NewOffer;